import { SortDirection } from "../types";
import { SharedAnalyticsFilters } from "./useAnalyticsFilters";

export interface AnalyticsQueryFilters extends SharedAnalyticsFilters {
  sortBy: string;
  sortDir: SortDirection;
}

export const buildAnalyticsParams = (f: AnalyticsQueryFilters): Record<string, string> => {
  const params: Record<string, string> = {
    timeRange: f.timeRange,
    mealPeriod: f.mealPeriod,
    sortBy: f.sortBy,
    sortDir: f.sortDir,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  if (f.timeRange === "custom" && f.startDate && f.endDate) {
    params.startDate = f.startDate;
    params.endDate = f.endDate;
  }
  if (f.teamId) {
    params.teamId = f.teamId;
  }
  return params;
};
